module.exports = __webpack_public_path__ + "static/media/card_house.78637dc9.jpg";